import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import Input from "../input/Input";
import { Dropdown } from "primereact/dropdown";
import Label from "../other/label";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RadioButton } from "primereact/radiobutton";
import {
  setCompanyName,
  setCeoFirstName,
  setCeoMiddleName,
  setCeoLastName,
  setSecFirstName,
  setSecLastName,
  setSecMiddleName,
  setIncorporationDate,
  setCompanyType,
  setCountryOfRegistration,
  setRegistrationOffice,
  setRegistrationNo,
  setRegistrationDate,
  setPanVatRegistraionNo,
  setIsSubsidiary,
  setNameAddressOfCompany,
  setTypesOfBusinessOfCompany,
  setAreaOfWork,
  setIsListed,
  setListingDate,
  setCompanyTypeOthers,
  setBusinessTypeOthers,
  setCompanyTypeDesc,
  setTypesOfBusinessOfCompanyDesc,
  setCountryOfRegistrationDesc,
  setIncorporationDateBs,
  setRegistrationDateBs,
  setListingDateBs,
  setHasPan,
  setPanEximption,
  setRegDistrict,
  setRegDistrictError,
  setPanEximptionError
} from "../../redux/companySlice";
import { getTValue } from "../other/label";

import { setDocumentTypeList } from "../../redux/documentSlice";
import { useState, useEffect } from "react";
import ApiService from "../service/apiService";
import { useForm, Controller } from "react-hook-form";
import { SaveButton } from "./declerationDetails";
import { NextButton } from "./kycSidebar";
import { filterCompanyDocument, filterDocument } from "./documentDetails";
import { DefaultDocumentComponent } from "./personalDetails";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import NepaliDatePicker2 from "../other/nepaliDatePicker";
import InputText from "../other/InputText";
import { InputMask } from "primereact/inputmask";
import AdBsDatePicker from "../other/adBsDatePicker";


const header = () => (
  <h3 className="p-col-12 p-md-12 text-center">
    <i className="pi pi-user" />
    Company Details
  </h3>
);

const footer = () => (
  <div class=" p-field p-col-12 p-md-12">
    <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
      <div style={{ flex: 1 }}></div>
      <div style={{ flex: 1 }}>
        <SaveButton />
      </div>
      <div style={{ flex: 1 }}>
        <NextButton />
      </div>
    </div>
  </div>
);

function CompanyDetails() {
  const { t, i18n } = useTranslation();
  const companyName = useSelector((state) => state.companyDetails.companyName);

  // const ceoName = useSelector(state => state.companyDetails.ceoName);
  // const secretaryName = useSelector(state => state.companyDetails.secretaryName);

  const ceoFirstName = useSelector(
    (state) => state.companyDetails.ceoFirstName
  );
  const ceoLastName = useSelector((state) => state.companyDetails.ceoLastName);
  const ceoMiddleName = useSelector(
    (state) => state.companyDetails.ceoMiddleName
  );
  const secFirstName = useSelector(
    (state) => state.companyDetails.secfirstName
  );
  const secLastName = useSelector((state) => state.companyDetails.secLastName);
  const secMiddleName = useSelector(
    (state) => state.companyDetails.secMiddleName
  );
  const incorporationDate = useSelector(
    (state) => state.companyDetails.incorporationDate
  ) || new Date();

  const incorporationDateBs = useSelector(
    (state) => state.companyDetails.incorporationDateBs
  );

  const companyType = useSelector((state) => state.companyDetails.companyType);
  const countryOfRegistration = useSelector(
    (state) => state.companyDetails.countryOfRegistration
  );
  const registrationOffice = useSelector(
    (state) => state.companyDetails.registrationOffice
  );
  const registrationNo = useSelector(
    (state) => state.companyDetails.registrationNo
  );
  const registrationDate = useSelector(
    (state) => state.companyDetails.registrationDate
  ) || new Date();
  const registrationDateBs = useSelector(
    (state) => state.companyDetails.registrationDateBs
  );

  const panVatRegistrationNo = useSelector(
    (state) => state.companyDetails.panVatRegistrationNo
  );


  const isSubsidiary = useSelector(
    (state) => state.companyDetails.isSubsidiary
  );
  const nameAddressOfCompany = useSelector(
    (state) => state.companyDetails.nameAddressOfCompany
  );
  const typesOfBusinessOfCompany = useSelector(
    (state) => state.companyDetails.typesOfBusinessOfCompany
  );

  const documentList = useSelector(
    (state) => state.documentDetails.documentList
  );
  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );
  const areaOfWork = useSelector((state) => state.companyDetails.areaOfWork);
  const isListed = useSelector((state) => state.companyDetails.isListed);
  const listingDate = useSelector((state) => state.companyDetails.listingDate) || new Date();
  const listingDateBs = useSelector(
    (state) => state.companyDetails.listingDateBs
  );

  const companyTypeOthers = useSelector(
    (state) => state.companyDetails.companyTypeOthers
  );
  const businessTypeOthers = useSelector(
    (state) => state.companyDetails.businessTypeOthers
  );

  const hasPan = useSelector(state => state.companyDetails.hasPan);
  const panEximption = useSelector(state => state.companyDetails.panEximption);
  const regDistrict = useSelector(state => state.companyDetails.regDistrict);
  const [loadingb, setLoadingb] = useState(false);
  const [loadingc, setLoadingc] = useState(false);
  const [loadingco, setLoadingco] = useState(false);
  const [loadingd, setLoadingd] = useState(false);
  const [loadingo, setLoadingo] = useState(false);
  const [officeList, setOfficeList] = useState([]);
  const [districtList, setDistrictList] = useState([]);
  const [companyTypeList, setCompanyTypeList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [businessTypeList, setBusinessTypeList] = useState([]);
  const formType = useSelector((state) => state.routerData.formType);

  const errorObj = useSelector((state) => state.companyDetails.errors);
  let {
    companyNameError,
    companyTypeError,
    registrationDateError,
    incorporationDateError,
    countryOfRegistrationError,
    registrationOfficeError,
    registrationNoError,
    panVatRegistrationNoError,
    isSubsidiaryError,
    nameAddressOfCompanyError,
    typesOfBusinessOfCompanyError,
    areaOfWorkError,
    isListedError,
    listingDateError,
    panEximptionError,
    regDistrictError,
  } = {};
  if (errorObj && errorObj.companyNameError) {
    companyNameError = errorObj.companyNameError.message;
  }
  if (errorObj && errorObj.companyTypeError) {
    companyTypeError = errorObj.companyTypeError.message;
  }
  if (errorObj && errorObj.registrationDateError) {
    registrationDateError = errorObj.registrationDateError.message;
  }
  if (errorObj && errorObj.incorporationDateError) {
    incorporationDateError = errorObj.incorporationDateError.message;
  }
  if (errorObj && errorObj.countryOfRegistrationError) {
    countryOfRegistrationError = errorObj.countryOfRegistrationError.message;
  }
  if (errorObj && errorObj.registrationOfficeError) {
    registrationOfficeError = errorObj.registrationOfficeError.message;
  }
  if (errorObj && errorObj.registrationNoError) {
    registrationNoError = errorObj.registrationNoError.message;
  }
  if (errorObj && errorObj.panVatRegistrationNoError) {
    panVatRegistrationNoError = errorObj.panVatRegistrationNoError.message;
  }
  if (errorObj && errorObj.isSubsidiaryError) {
    isSubsidiaryError = errorObj.isSubsidiaryError.message;
  }
  if (errorObj && errorObj.nameAddressOfCompanyError) {
    nameAddressOfCompanyError = errorObj.nameAddressOfCompanyError.message;
  }
  if (errorObj && errorObj.typesOfBusinessOfCompanyError) {
    typesOfBusinessOfCompanyError =
      errorObj.typesOfBusinessOfCompanyError.message;
  }
  if (errorObj && errorObj.areaOfWorkError) {
    areaOfWorkError = errorObj.areaOfWorkError.message;
  }
  if (errorObj && errorObj.isListedError) {
    isListedError = errorObj.isListedError.message;
  }
  if (errorObj && errorObj.listingDateError) {
    listingDateError = errorObj.listingDateError.message;
  }
  if (errorObj && errorObj.panEximptionError) {
    panEximptionError = errorObj.panEximptionError.message;
  }
  if (errorObj && errorObj.regDistrictError) {
    regDistrictError = errorObj.regDistrictError.message;
  }

  const dispatch = useDispatch();

  useEffect(() => {
    setLoadingb(true);
    setLoadingc(true);
    setLoadingco(true);
    setLoadingd(true);
    ApiService.getCompanyTypeList().then((response) => {
      console.log(response.data);
      setCompanyTypeList(response.data.data);
      console.log(companyTypeList);
    }).finally(() => setLoadingb(false));

    ApiService.getCountryList().then((response) => {
      console.log(response.data);
      setCountryList(response.data.data);
      console.log(countryList);
    }).finally(() => setLoadingco(false));

    ApiService.getDistrictList().then((response) => {
      console.log(response.data);
      setDistrictList(response.data.data);
      console.log(districtList);
    }).finally(() => setLoadingd(false));

    ApiService.getOfficeList().then((response) => {
      console.log(response.data);
      setOfficeList(response.data);
      console.log(officeList);
    }).finally(() => setLoadingo(false));

    ApiService.getBusinessTypeList().then((response) => {
      console.log(response.data);
      setBusinessTypeList(response.data.data);
      console.log(businessTypeList);
    }).finally(() => setLoadingc(false));

    ApiService.getDocumentTypeList().then((response) => {
      console.log("doc", response);
      dispatch(setDocumentTypeList(response.data.data));
    });
  }, []);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});

  function isValidDate(date) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!date.match(regEx)) return false; // Invalid format
    var d = new Date(date);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === date;
  }

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-user" /> {t("companyDetails")}
        </h3>
      }
      footer={footer}
    >
      <div className="p-grid p-fluid">
        <div className="p-field p-col-12 p-md-12">
          <label className="p-col-12 p-md-12" htmlFor="companyName">
            {t("companyName")}*
          </label>
          <div className="p-inputgroup">
            <InputText
              keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
              clearSpace
              value={companyName}
              onChange={(e) => {
                dispatch(setCompanyName(e.target.value.toUpperCase()));
              }}
              placeholder={t("cName")}
            />
          </div>
          <span style={{ color: "red" }}>{companyNameError}</span>
        </div>

        <Controller
          name="incorporationDate"
          control={control}
          rules={{
            required: "Incorporation Date is required.",
          }}
          render={({ field, fieldState }) => (
            <AdBsDatePicker
              css={companyType === "O" ? "p-md-3" : "p-md-4"}
              label={t("incorporationDate")}
              bsDate={incorporationDateBs}
              adDate={incorporationDate}
              adError={incorporationDateError}
              onChange={(adDate, bsDate, extra) => {
                field.onChange(adDate);

                dispatch(setIncorporationDate(adDate));
                dispatch(setIncorporationDateBs(bsDate));
              }} />
          )}
        />


        <div
          className={
            "p-field p-col-12 stick-left" +
            (companyType === "O" ? " stick-right p-md-3" : " p-md-4")
          }
        >
          <label className="p-col-12 p-md-12" htmlFor="companyType">
            {t("typesOfCompany")}*
          </label>
          <Controller
            name="companyType"
            control={control}
            rules={{ required: "Company Type is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={companyType}
                filter showClear
                disabled={loadingc}
                dropdownIcon={loadingc ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  field.onChange(e.value);
                  dispatch(setCompanyType(e.value));
                  dispatch(
                    setCompanyTypeDesc(
                      e.originalEvent.nativeEvent.target.ariaLabel
                    )
                  );
                  if (e.value !== "O") {
                    dispatch(setCompanyTypeOthers(null));
                  }
                }}
                options={companyTypeList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectCompanyType")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{companyTypeError}</span>
        </div>
        {companyType === "O" ? (
          <>
            <div className="p-field p-col-12 p-md-3 stick-left">
              <label className="p-col-12 p-md-12" htmlFor="Others">
                {t("companyTypeOthers")}
              </label>
              <div className="p-inputgroup">
                <InputText
                  isName
                  value={companyTypeOthers}
                  onChange={(e) => {
                    dispatch(setCompanyTypeOthers(e.target.value));
                  }}
                  placeholder={t("companyTypeOthers")}
                />
              </div>
            </div>
          </>
        ) : null}
        <div className="p-field p-col-12 p-md-4 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="countryOfRegistration">
            {t("countryOfRegistration")}*
          </label>
          <Controller
            name="countryOfRegistration"
            control={control}
            rules={{ required: "Country is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={countryOfRegistration}
                filter showClear
                disabled={loadingco}
                dropdownIcon={loadingco ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  field.onChange(e.value);
                  dispatch(setCountryOfRegistration(e.value));
                }}
                options={countryList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectCountryOfRegistration")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{countryOfRegistrationError}</span>
        </div>
        {documentTypeList.map((p) => {
          if (p.type === "C" && p.code === "CRN") {
            return (
              <>
                <div className="p-field p-col-12 p-md-4 stick-left stick-right">
                  <label
                    className="p-col-12 p-md-12"
                    htmlFor="registrationOffice"
                  >
                    {t("registrationOffice")}
                  </label>
                  <div className="p-inputgroup">
                    <Input
                      value={registrationOffice}
                      onChange={(e) => {
                        dispatch(setRegistrationOffice(e.target.value));
                      }}
                      placeholder={t("registrationOffice")}
                    />
                  </div>
                  <span style={{ color: "red" }}>
                    {registrationOfficeError}
                  </span>
                </div>
                <div className="p-field p-col-12 p-md-4 stick-left stick-right">
                  <label className="p-col-12 p-md-12" htmlFor="registrationNo">
                    {t("registrationNo")}
                  </label>
                  <div className="p-inputgroup">
                    <Input
                      value={registrationNo}
                      onChange={(e) => {
                        dispatch(setRegistrationNo(e.target.value));
                      }}
                      placeholder={t("registrationNo")}
                    />
                  </div>
                  <span style={{ color: "red" }}>{registrationNoError}</span>
                </div>
                <AdBsDatePicker
                  label={t("registrationDate")}
                  bsDate={registrationDateBs}
                  adDate={registrationDate}
                  adError={registrationDateError}
                  onChange={(adDate, bsDate, extra) => {
                    dispatch(setRegistrationDateBs(bsDate));
                    dispatch(
                      setRegistrationDate(adDate)
                    );

                  }} />

              </>
            );
          }
        })}
        <div className="p-field p-col-12 p-md-4 stick-left stick-right">
          <label
            className="p-col-12 p-md-12"
            htmlFor="registrationOffice"
          >
            {t("registrationOffice")}*
          </label>
          <Controller
            name="registrationOffice"
            control={control}
            rules={{ required: "Office is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={registrationOffice}
                filter showClear
                disabled={loadingo}
                dropdownIcon={loadingo ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  field.onChange(e.value);
                  dispatch(setRegistrationOffice(e.value));
                }}
                options={officeList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectRegistrationOffice")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{registrationOfficeError}</span>
        </div>
        <div className="p-field p-col-12 p-md-4 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="regDistrict">
            {t("regDistrict")}*
          </label>
          <Controller
            name="regDistrict"
            control={control}
            rules={{ required: "District is required." }}
            render={({ field, fieldState }) => (
              <Dropdown
                id={field.id}
                value={regDistrict}
                filter showClear
                disabled={loadingd}
                dropdownIcon={loadingd ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                onChange={(e) => {
                  field.onChange(e.value);
                  dispatch(setRegDistrict(e.value));
                }}
                options={districtList}
                optionLabel={(data) =>
                  getTValue(i18n, data.descEng, data.descNep)
                }
                placeholder={t("selectRegDistrict")}
                optionValue="code"
              />
            )}
          />
          <span style={{ color: "red" }}>{regDistrictError}</span>
        </div>

        <div className="p-field p-col-12 p-md-4 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="registrationNo">
            {t("registrationNo")}*
          </label>
          <div className="p-inputgroup">
            <Input
              value={registrationNo}
              onChange={(e) => {
                dispatch(setRegistrationNo(e.target.value));
              }}
              placeholder={t("registrationNo")}
            />
          </div>
          <span style={{ color: "red" }}>{registrationNoError}</span>
        </div>

        <AdBsDatePicker
          label={t("registrationDate")}
          bsDate={registrationDateBs}
          adDate={registrationDate}
          adError={registrationDateError}
          onChange={(adDate, bsDate, extra) => {
            dispatch(setRegistrationDateBs(bsDate));
            dispatch(setRegistrationDate(adDate));
          }} />


        {/* <div className="p-field p-col-12 p-md-4 stick-left stick-right">
          <label className="p-col-12 p-md-12" htmlFor="panVatRegistrationNo">
            {t("panVatRegistrationNo")}*
          </label>
          <div className="p-inputgroup">
            <InputMask
              mask="999999999"
              value={panVatRegistrationNo}
              keyfilter="num"
              onChange={(e) => {
                dispatch(setPanVatRegistraionNo(e.target.value));
              }}
              placeholder={t("panVatRegistrationNo")}
            />
          </div>
          <span style={{ color: "red" }}>{panVatRegistrationNoError}</span>
        </div> */}

        <div className="p-field p-col-12 p-md-4 stick-right">
          <label className="p-col-12 p-md-12" htmlFor="hasPan">
            {t("isPanExempted?")}*

          </label>
          <div className="p-field-radiobutton p-col-12 p-ml-2">
            <RadioButton
              name="hasPan"
              inputId="yes"
              value={false}
              onChange={(e) => {
                dispatch(setHasPan(e.value));
                dispatch(setPanVatRegistraionNo(""));
                dispatch(setPanEximption(""));
              }}
              checked={hasPan === false}
            />
            <label className="p-mr-5" htmlFor="hasPanYes">
              {t("yes")}
            </label>
            <RadioButton
              name="hasPan"
              inputId="no"
              value={true}
              onChange={(e) => {
                dispatch(setHasPan(e.value));
                dispatch(setPanVatRegistraionNo(""));
                dispatch(setPanEximption(""));
              }}
              checked={hasPan === true}
            />
            <label className="p-mr-5" htmlFor="isSubsidiaryNo">
              {t("no")}
            </label>
          </div>
          {/* <span style={{ color: "red" }}>{hasPanError}</span> */}
        </div>
        {hasPan &&
          <div className="p-field p-col-12 p-md-4 stick-left stick-right">
            <label className="p-col-12 p-md-12" htmlFor="panVatRegistrationNo">
              {t("panVatRegistrationNo")}*
            </label>
            <div className="p-inputgroup">
              <InputMask
                mask="999999999"
                value={panVatRegistrationNo}
                keyfilter="num"
                onChange={(e) => {
                  dispatch(setPanVatRegistraionNo(e.target.value));
                }}
                placeholder={t("panVatRegistrationNo")}
              />
            </div>
            <span style={{ color: "red" }}>{panVatRegistrationNoError}</span>
          </div>}

        <div className="p-field p-col-12 p-md-4 stick-left">
          <label className="p-col-12 p-md-12" htmlFor="isSubsidiary">
            {t("isSubsidiary")}*
          </label>
          <div className="p-field-radiobutton p-col-12 p-ml-2">
            <RadioButton
              name="isSubsidiary"
              inputId="yes"
              value={true}
              onChange={(e) => {
                dispatch(setIsSubsidiary(e.value));
              }}
              checked={isSubsidiary === true}
            />
            <label className="p-mr-5" htmlFor="isSubsidiaryYes">
              {t("yes")}
            </label>
            <RadioButton
              name="isSubsidiary"
              inputId="no"
              value={false}
              onChange={(e) => {
                dispatch(setIsSubsidiary(e.value));
              }}
              checked={isSubsidiary === false}
            />
            <label className="p-mr-5" htmlFor="isSubsidiaryNo">
              {t("no")}
            </label>
          </div>
          <span style={{ color: "red" }}>{isSubsidiaryError}</span>
        </div>
        {!hasPan &&
          <div className="p-field p-col-12 p-md-12 ">
            <label className="p-col-12 p-md-12" htmlFor="panEximption">
              {t("panEximption")}*
            </label>
            <div className="p-inputgroup">
              <InputText
                value={panEximption}
                keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                onChange={(e) => {
                  dispatch(setPanEximption(e.target.value));
                }}
                placeholder={t("panEximption")}
              />
            </div>
            <span style={{ color: "red" }}>{panEximptionError}</span>
          </div>
        }
        {isSubsidiary === true ? (
          <div className="p-field p-col-12 p-md-12">
            <label
              className="p-col-12 p-md-12"
              htmlFor="nameAndAddressOfMainCompany"
            >
              {t("nameAddressOfCompany")}
            </label>
            <div className="p-inputgroup">
              <InputText
                isName
                keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                value={nameAddressOfCompany}
                onChange={(e) => {
                  dispatch(setNameAddressOfCompany(e.target.value));
                }}
                placeholder={t("nameAddressOfCompany")}
              />
            </div>
            <span style={{ color: "red" }}>{nameAddressOfCompanyError}</span>
          </div>
        ) : null}

        <>
          <div
            className={
              "p-field p-col-12 stick-right" +
              (typesOfBusinessOfCompany === "O" ? " p-md-3" : " p-md-4")
            }
          >
            <label
              className="p-col-12 p-md-12"
              htmlFor="typesOfBusinessOfCompany"
            >
              {t("typesOfBusinessCompany")}
            </label>
            <Controller
              name="businessType"
              control={control}
              rules={{ required: "Business Type is required." }}
              render={({ field, fieldState }) => (
                <Dropdown
                  id={field.id}
                  value={typesOfBusinessOfCompany}
                  filter showClear
                  disabled={loadingb}
                  dropdownIcon={loadingb ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                  onChange={(e) => {
                    field.onChange(e.value);
                    dispatch(setTypesOfBusinessOfCompany(e.value));
                    dispatch(
                      setTypesOfBusinessOfCompanyDesc(
                        e.originalEvent.nativeEvent.target.ariaLabel
                      )
                    );
                    if (e.value !== "O") {
                      dispatch(setBusinessTypeOthers(null));
                    }
                  }}
                  options={businessTypeList}
                  optionLabel={(data) =>
                    getTValue(i18n, data.descEng, data.descNep)
                  }
                  placeholder={t("selectBusinessType")}
                  optionValue="code"
                />
              )}
            />
            <span style={{ color: "red" }}>
              {typesOfBusinessOfCompanyError}
            </span>
          </div>
          {typesOfBusinessOfCompany === "O" ? (
            <>
              <div className="p-field p-col-12 p-md-3 stick-left stick-right">
                <label
                  className="p-col-12 p-md-12"
                  htmlFor="othersBusinessType"
                >
                  {t("businessTypeOthers")}
                </label>
                <div className="p-inputgroup">
                  <Input
                    value={businessTypeOthers}
                    onChange={(e) => {
                      dispatch(setBusinessTypeOthers(e.target.value));
                    }}
                    placeholder={t("businessTypeOthers")}
                  />
                </div>
              </div>
            </>
          ) : null}
          <div
            className={
              "p-field p-col-12 stick-right stick-left " +
              (typesOfBusinessOfCompany === "O" ? " p-md-3" : " p-md-4")
            }
          >
            <label className="p-col-12 p-md-12" htmlFor="areaOfWork">
              {t("areaOfWork")}
            </label>
            <div className="p-inputgroup">
              <Input
                value={areaOfWork}
                keyfilter={/^[a-zA-Z0-9\-\.\,\/\(\) ]$/}
                onChange={(e) => {
                  dispatch(setAreaOfWork(e.target.value));
                }}
                placeholder={t("areaOfWork")}
              />
            </div>
            <span style={{ color: "red" }}>{areaOfWorkError}</span>
          </div>
          <div
            className={
              "p-field p-col-12 stick-left" +
              (typesOfBusinessOfCompany === "O" ? " p-md-3" : " p-md-4")
            }
          >
            <label className="p-col-12 p-md-12" htmlFor="isListed">
              {t("isListed")}
            </label>
            <div className="p-field-radiobutton p-col-12 p-ml-2">
              <RadioButton
                name="isListed"
                inputId="isListedYes"
                value={true}
                onChange={(e) => {
                  dispatch(setIsListed(e.value));
                }}
                checked={isListed === true}
              />
              <label className="p-mr-5" htmlFor="isListedYes">
                {t("yes")}
              </label>
              <RadioButton
                name="isListed"
                inputId="isListedNo"
                value={false}
                onChange={(e) => {
                  dispatch(setIsListed(e.value));
                }}
                checked={isListed === false}
              />
              <label className="p-mr-5" htmlFor="isListedNo">
                {t("no")}
              </label>
            </div>
            <span style={{ color: "red" }}>{isListedError}</span>
          </div>
          {isListed ? (
            <>
              <Controller
                name="listingDate"
                control={control}
                // rules={{
                //   required: "Incorporation Date is required.",
                // }}
                render={({ field, fieldState }) => (
                  <AdBsDatePicker
                    label={t("listingDate")}
                    bsDate={listingDateBs}
                    adDate={listingDate}
                    adError={listingDateError}
                    onChange={(adDate, bsDate, extra) => {
                      field.onChange(adDate);

                      dispatch(setListingDateBs(bsDate));
                      dispatch(setListingDate(adDate));
                    }} />
                )}
              />
            </>
          ) : null}

        </>
        {/* {documentList
          .filter((p) => !p.usedFor && filterCompanyDocument(p))
          .map((p) => {
            return <DefaultDocumentComponent data={p} />;
          })} */}
      </div>
    </Card>
  );
}

export default CompanyDetails;
